// 사운드 재생을 위한 유틸리티 함수들

// 사운드 파일 경로들 (public 폴더 기준)
export const SOUND_PATHS = {
  BUTTON_CLICK: '/sounds/button-click.wav',
  POPUP_SOUND: '/sounds/popup-sound.wav',
} as const;

// 사운드 재생 함수 (모든 효과음 비활성화)
export const playSound = (soundPath: string, volume: number = 0.5): void => {
  // 모든 효과음 비활성화 - 아무것도 하지 않음
  return;
};

// 버튼 클릭음 재생 함수 (비활성화)
export const playButtonClickSound = (volume: number = 0.3): void => {
  // 모든 효과음 비활성화 - 아무것도 하지 않음
  return;
};

// 팝업 사운드 재생 함수 (비활성화)
export const playPopupSound = (volume: number = 0.4): void => {
  // 모든 효과음 비활성화 - 아무것도 하지 않음
  return;
};

// 사운드 설정 (사용자가 사운드를 끄고 켤 수 있도록)
export class SoundManager {
  private static instance: SoundManager;
  private isEnabled: boolean = false;
  private volume: number = 0.3;
  private audioContext: AudioContext | null = null;
  private isAudioContextInitialized: boolean = false;

  private constructor() {
    // 로컬 스토리지에서 사운드 설정 불러오기
    const savedSetting = localStorage.getItem('soundEnabled');
    if (savedSetting !== null) {
      this.isEnabled = JSON.parse(savedSetting);
    }
    
    const savedVolume = localStorage.getItem('soundVolume');
    if (savedVolume !== null) {
      this.volume = parseFloat(savedVolume);
    }
  }

  public static getInstance(): SoundManager {
    if (!SoundManager.instance) {
      SoundManager.instance = new SoundManager();
    }
    return SoundManager.instance;
  }

  private initializeAudioContext(): void {
    if (!this.isAudioContextInitialized) {
      try {
        // AudioContext 생성 (사용자 상호작용 후에만 가능)
        this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
        this.isAudioContextInitialized = true;
      } catch (error) {
        console.warn('오디오 컨텍스트 초기화 실패:', error);
      }
    }
  }

  public playButtonClick(): void {
    // 모든 효과음 비활성화 - 아무것도 하지 않음
    return;
  }

  public playPopupSound(): void {
    // 모든 효과음 비활성화 - 아무것도 하지 않음
    return;
  }

  public setEnabled(enabled: boolean): void {
    this.isEnabled = enabled;
    localStorage.setItem('soundEnabled', JSON.stringify(enabled));
  }

  public setVolume(volume: number): void {
    this.volume = Math.max(0, Math.min(1, volume)); // 0-1 범위로 제한
    localStorage.setItem('soundVolume', volume.toString());
  }

  public isSoundEnabled(): boolean {
    return this.isEnabled;
  }

  public getVolume(): number {
    return this.volume;
  }
}

// 편의를 위한 전역 함수들
export const soundManager = SoundManager.getInstance();

// 사운드 테스트 함수 (개발용)
export const testSound = (): void => {
  
  try {
    const audio = new Audio(SOUND_PATHS.BUTTON_CLICK);
    audio.volume = 0.5;
    
    audio.addEventListener('error', (e) => console.error('사운드 로드 오류:', e));
    
    audio.play().then(() => {
    }).catch((error) => {
      console.error('사운드 재생 실패:', error);
    });
  } catch (error) {
    console.error('사운드 테스트 오류:', error);
  }
};
